<template lang='pug'>
  v-dialog(v-model="showDialog" scrollable width="720px")
    v-card
      v-card-title.title-bar
        span.text-subtitle-1(:class="{'selected-title': infoIndex==0}" @click="infoIndex=0") Modeling
        span.text-subtitle-1(:class="{'selected-title': infoIndex==1}" @click="infoIndex=1") Posing
        span.text-subtitle-1(:class="{'selected-title': infoIndex==2}" @click="infoIndex=2") Use &amp; Tips
      InfoGenerate(v-if="infoIndex==0" @show-info-pose="infoIndex=1" @show-info-tips="infoIndex=2")
      InfoPose(v-if="infoIndex==1" @show-info-generate="infoIndex=0" @show-info-tips="infoIndex=2")
      InfoEditorTips(v-if="infoIndex==2"
                     :showCameraNavigateMode='isTouchMode'
                     @show-info-generate="infoIndex=0"
                     @show-info-pose="infoIndex=1")
      v-card-actions
        v-spacer
        v-btn(color="accent" @click="closeDialog") Close
</template>

<script>
import InfoGenerate from '@/components/day6/infos/day6-info-generate'
import InfoPose from '@/components/day6/infos/day6-info-pose'
import InfoEditorTips from '@/components/day6/infos/day6-info-editor'

export default {
  name: 'Day6Info',
  components: { InfoGenerate, InfoPose, InfoEditorTips },
  props: {
    show: { type: Boolean },
    isTouchMode: Boolean
  },
  model: {
    prop: 'show',
    event: 'change'
  },
  data: function () {
    return {
      showDialog: false,
      infoIndex: 0
    }
  },
  watch: {
    show (val) {
      this.showDialog = val
    },
    showDialog (val) {
      if (!val) {
        this.closeDialog()
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('change', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.title-bar {
  &>* {
    margin-right: 16px;
  }

  :not(.selected-title) {
    color: var(--v-accent-base);
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
